// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f3c56b23","54":"7d796fe7","365":"17d610a3","453":"d456ce70","825":"ae55d0ea"}[chunkId] + ".chunk.js";
};